import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../lib/api-client';
import {OrderStatus} from '../types/enums';
import {LookupValue} from '../types/LookupValue';

export const useGetLookupValuesByType = (lookupType: string, enabled: boolean = true) => {
    const { data, isLoading } = useQuery({
        queryKey: ['lookup-by-type', lookupType],
        queryFn: async () => await apiClient.get('lookup/values-by-type', {
            params: {
                lookupType: lookupType
            }
        }) as LookupValue[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};

export const useGetOrderStatuses = (enabled: boolean = true) => {
    const { data, isLoading } = useQuery({
        queryKey: ['order-statuses'],
        queryFn: async () => await apiClient.get('lookup/order-statuses') as OrderStatus[],
        enabled: enabled
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
